import { create } from 'zustand';
import { IFullStep } from '../../../core/components/molecules/FullStepIndicator';
import { disciplines, weekDays } from '../utils/common';

type PlanConfigStep = IFullStep & {
  nextStepButtonLabel: string;
};

export interface IPlanConfigWorkload {
  weekDay: number;
  hours: number;
}

export interface IPlanConfigDisciplinesByDay {
  discipline: string;
  weekDays: number[];
  essayDay?: number;
  selected?: boolean;
}

export interface IPlanConfig {
  dailyWorkload: IPlanConfigWorkload[];
  disciplinesByDay: IPlanConfigDisciplinesByDay[];
  initialDate?: string;
  initialDateOption?: 'immediate' | 'custom_date';
  finalDate?: string;
  finalDateOption?: 'until_enem_2027' | 'custom_date';
  hasPause?: boolean;
  pauseRanges?: {
    dateStart: string;
    dateEnd: string;
  }[];
}

interface IPlanConfigState {
  steps: PlanConfigStep[];
  markStepAsDone: (key: string) => void;
  markStepAsNotDone: (key: string) => void;
  currentStep: PlanConfigStep;
  setCurrentStep: (step: PlanConfigStep) => void;
  planConfig: IPlanConfig;
  updatePlanConfig: (planConfig: IPlanConfig | Partial<IPlanConfig>) => void;
  resetPlanConfig: () => void;
  isEditMode: boolean;
  setEditMode: (isEditMode: boolean) => void;
}

const getInitialPlanConfig = (): IPlanConfig => ({
  dailyWorkload: weekDays.map((day) => ({
    weekDay: day.weekDay,
    hours: 0,
  })),
  disciplinesByDay: disciplines.map((discipline) => ({
    discipline: discipline.disciplineSlug,
    weekDays: [],
    selected: false,
  })),
  initialDate: undefined,
  initialDateOption: undefined,
  finalDate: undefined,
  finalDateOption: undefined,
  pauseRanges: [
    {
      dateStart: '',
      dateEnd: '',
    },
  ],
});

export const usePlanConfigStore = create<IPlanConfigState>((set) => {
  const steps: PlanConfigStep[] = [
    {
      key: 'PlanConfigStart',
      nextStepButtonLabel: 'Próximo',
      label: 'Início',
      done: false,
    },
    {
      key: 'Diagnostico',
      nextStepButtonLabel: 'Próximo',
      label: 'Simulado Diagnóstico',
      done: false,
    },
    {
      key: 'DailyWorkload',
      nextStepButtonLabel: 'Próximo',
      label: 'Disciplinas',
      done: false,
    },
    // {
    //   key: 'Disciplines',
    //   nextStepButtonLabel: 'Próximo',
    //   label: 'Disciplinas',
    //   done: false,
    // },
    {
      key: 'FinalDate',
      nextStepButtonLabel: 'Próximo',
      label: 'Data final',
      done: false,
    },
    {
      key: 'Preview',
      nextStepButtonLabel: 'Gerar Cronograma',
      label: 'Preview',
      done: false,
    },
  ];

  return {
    steps,
    currentStep: steps[0],
    setCurrentStep: (step) => set({ currentStep: step }),
    markStepAsDone: (key) =>
      set((state) => ({
        steps: state.steps.map((s) =>
          s.key === key ? { ...s, done: true } : s
        ),
      })),
    markStepAsNotDone: (key) =>
      set((state) => ({
        steps: state.steps.map((s) =>
          s.key === key ? { ...s, done: false } : s
        ),
      })),
    planConfig: getInitialPlanConfig(),
    isEditMode: false,
    setEditMode: (isEditMode) => set({ isEditMode }),
    updatePlanConfig: (planConfig) =>
      set((state) => ({
        planConfig: { ...state.planConfig, ...planConfig },
      })),
    resetPlanConfig: () => set({ planConfig: getInitialPlanConfig() }),
  };
});
